import { Grid } from '@mui/material';
import { WsTypoVariants, WsTypography } from 'wisestep-base';

import NoCandidatesSVG from '../../../../../images/content/NoCandidates.svg';

interface NoPreviewProps {
  text?: string;
}
const NoPreview = ({ text }: NoPreviewProps) => (
  <Grid
    sx={{
      height: '550px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    }}
    id="noMappingRightPane"
  >
    <img src={NoCandidatesSVG} alt="No Candidate ?" height={200} width={200} />
    <Grid mt={3}>
      <WsTypography variant={WsTypoVariants.SUB_TITLE}>
        {`Preview will be available after ${text}`}{' '}
      </WsTypography>
    </Grid>
  </Grid>
);

export default NoPreview;
